import { motion } from "framer-motion";
import SpotlightSection, { VisualFrame } from "@/components/wynn/SpotlightSection";

function MeditationVisual() {
  return (
    <VisualFrame
      gradient="linear-gradient(135deg, rgba(168,230,255,0.28) 0%, rgba(230,191,255,0.24) 55%, rgba(255,183,198,0.2) 100%)"
    >
      <div aria-hidden className="absolute inset-0 grid place-items-center">
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="rounded-full border border-[#F4F1EC]/25"
            style={{ gridArea: "1 / 1", width: 120 + i * 80, height: 120 + i * 80 }}
            animate={{ scale: [1, 1.12, 1], opacity: [0.5, 0.18, 0.5] }}
            transition={{ duration: 4 + i, repeat: Infinity, ease: "easeInOut" }}
          />
        ))}
      </div>
      <div className="relative text-center">
        <div className="font-display text-[26px] italic font-light text-[#F4F1EC]">Meditations</div>
        <div className="mt-2 text-[10px] uppercase tracking-[0.3em] text-[#F4F1EC]/70 font-body">
          Morning · Evening · Activation
        </div>
      </div>
    </VisualFrame>
  );
}

export default function MeditationsSpotlight() {
  return (
    <SpotlightSection
      id="meditations"
      testId="wynn-meditations"
      reverse
      labelColor="#A8E6FF"
      label="Meditations · in the full app"
      lead="Sound to open"
      accent="the channel"
      body="Two libraries of guided meditations and sound healing — for creative activation, for the morning's first breath, for the evening's letting-go, and for the days you simply can't. Press play and let the noise settle until the work can reach you again."
      tags={["Creative activation", "Morning", "Evening", "Sound healing"]}
      accentGradient="radial-gradient(50% 55% at 82% 25%, rgba(168,230,255,0.20) 0%, rgba(7,6,8,0) 60%), radial-gradient(50% 55% at 15% 80%, rgba(230,191,255,0.16) 0%, rgba(7,6,8,0) 65%)"
      visual={<MeditationVisual />}
    />
  );
}
